<kendo-formfield >
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-multiselect
        [ngClass]="{'fx-fill': settings.fxFill}"
        valuePrimitive="true"
        [data]="valueList$ | async"
        [formControl]="control" 
        [textField]="textField" 
        [valueField]="valueField"
        [checkboxes]="true"
        [autoClose]="false"
        (valueChange)="onChange($event)">

        <ng-template *ngIf="addSelectAllButton" kendoMultiSelectHeaderTemplate >
            <div fxLayoutAlign="center center">
                <strong role="none" class="clickable" (click)="selectAll()">
                    {{ 'global.selectAll' | translate }}
                </strong>
            </div>
          </ng-template>

    </kendo-multiselect>
    </kendo-formfield>
